import { gql } from '@apollo/client/core';

export const VIEWER_AVAILABILITIES_QUERY = gql`
  query ($count: Int, $after: String) {
    viewer(kind: SITTER) {
      ... on Sitter {
        location {
          timeZone
        }
        availabilities(first: $count, after: $after) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            node {
              start
              end
              kind
              repeatingAvailability {
                id
                schedule
                effectiveUntil
              }
              cause {
                ... on InterviewContract {
                  id
                  interviewContractKind
                  parent {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const ACCOUNT_AVAILABILITIES_QUERY = gql`
  query ($id: UUID!, $kind: AccountKind!, $count: Int, $after: String, $afterTime: DateTime, $beforeTime: DateTime) {
    account(id: $id, kind: $kind) {
      id
      ... on Sitter {
        availabilities(first: $count, after: $after, afterTime: $afterTime, beforeTime: $beforeTime) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          lastUpdatedAt
          edges {
            cursor
            node {
              start
              end
              kind
              repeatingAvailability {
                id
                schedule
                effectiveUntil
              }
            }
          }
        }
      }
    }
  }
`;

export const AVAILABILITY_CHECKS = gql`
  query {
    availabilityChecks
  }
`;

export default {
  availabilities: VIEWER_AVAILABILITIES_QUERY,
  accounts: ACCOUNT_AVAILABILITIES_QUERY,
};
